export const BASE_URL = '/store/admin/digitalassets';


export const HOME_PAGE = `${BASE_URL}/home`;
export const ADMIN_PAGE = `${BASE_URL}/edam/bulkupload/admin`;
export const LOGIN_PAGE = `${BASE_URL}/`;
export const JOB_STATUS_DETIALS = `${BASE_URL}/job-status-detail-view/:id`;
export const S3_UPLOAD = `${BASE_URL}/s3-upload`;
export const JOB_STATUS_PAGE = `${BASE_URL}/job-status`;
export const FOLDERS = `${BASE_URL}/folders`;

// New routes added for the new pages
export const ASSET_UPLOAD = `${BASE_URL}/asset-upload`;
export const HOME_PAGEV1 = `${BASE_URL}/homev1`;
export const JOBS = `${BASE_URL}/jobs`;
export const JOB_DETAILS = `${BASE_URL}/job-details/:id`;
export const ASSET_DETAIL = `${BASE_URL}/asset-detail/:id`;
export const ASSET_EDIT = `${BASE_URL}/asset-edit/:id`;
export const ASSET_CHECK_IN = `${BASE_URL}/asset-check-in/:id`;
export const NIFI_REPORT = `${BASE_URL}/nifi-report`;
